<template>
  <ul-page fullBody higher :fullHeader="false" class="page-login">
    <template v-slot:right>
      <div class="page-header-right">
        <span @click="getHelp">联系客服</span>
        <span @click="toHome">网站首页</span>
      </div>
    </template>
    <div class="banner"></div>
    <div class="mobile-logo">
      <img src="@/assets/images/logo.png" alt="" />
    </div>
    <Login ref="login" v-show="mode == 1">
      <div class="register register-mobile">
        <a href="javascript:;" @click="toRegister">去注册</a>
        <a href="javascript:;" @click="toFindPwd">忘记密码？</a>
      </div>
      <ul-button class="btn-submit" type="primary" @click="login"
        >登录</ul-button
      >
      <div class="register register-pc">
        <a href="javascript:;" @click="toRegister">去注册</a>
        <a href="javascript:;" @click="toFindPwd">忘记密码？</a>
      </div>
      <div class="others-container pc-others">
        <div class="others-title">
          <div class="line">
            <div class="title">其他登录方式</div>
          </div>
        </div>
        <div class="others-wrapper">
          <div class="others-item" @click="orgLoginSwitch">
            <i class="iconfont icon-jigouzhanghao"></i>
            <div class="desc">机构账号登录</div>
          </div>
          <div class="others-item" @click="mode = 2">
            <i class="iconfont icon-duanxin"></i>
            <div class="desc">短信登录</div>
          </div>
          <div class="others-item" @click="wxLogin" v-if="showWxLogin">
            <i class="iconfont icon-wechat"></i>
            <div class="desc">微信登录</div>
          </div>
          <!-- 暂时隐藏welink登录 -->
          <!-- <div class="others-item" @click="welinkLogin" v-if="showWelink">
            <img class="welink-icon" src="@/assets/images/welink.png" />
            <div class="desc">welink登录</div>
          </div> -->
        </div>
      </div>
    </Login>
    <div class="form-container" v-show="mode == 2">
      <div class="back" @click="cancelPhoneLogin">
        <i class="iconfont icon-zuoye"></i><span>返回</span>
      </div>
      <h1 class="form-title">短信登录</h1>
      <ul-form
        class="form-login"
        ref="loginFormPhone"
        :model="user"
        :rules="rulesPhone"
      >
        <ul-form-item prop="cellphone" label-width="0">
          <ul-input v-model="user.cellphone" placeholder="请输入手机号">
            <template slot="prepend">+86</template>
          </ul-input>
        </ul-form-item>
        <ul-form-item
          class="form-item-code"
          prop="code"
          label-width="0"
          :error="phoneErrorMsg"
        >
          <ul-input
            v-model="user.code"
            placeholder="请输入验证码"
            @keydown.native.enter="loginPhone"
          ></ul-input>
          <ul-button
            class="btn-code"
            disabled
            v-if="remaining > 0 && remaining < 60"
            >重新获取({{ remaining }})</ul-button
          >
          <ul-button
            class="btn-code"
            v-else
            :disabled="user.cellphone == ''"
            @click="getPhoneCode"
            >获取验证码</ul-button
          >
        </ul-form-item>
        <div class="phone-tips">*短信登录仅支持中国大陆手机号</div>
        <ul-button class="btn-submit" type="primary" @click="loginPhone"
          >登录</ul-button
        >
      </ul-form>
    </div>
    <div class="form-container" v-show="mode == 3">
      <div class="back" @click="cancelImageCode">
        <i class="iconfont icon-zuoye"></i><span>返回</span>
      </div>
      <h1 class="form-title">身份验证</h1>
      <div class="image-code-wrapper">
        <img :src="image.url" alt="" v-if="image.url" />
      </div>
      <ul-form class="form-login" ref="loginFormImg">
        <ul-form-item prop="cellphone" label-width="0" :error="image.errorMsg">
          <ul-input v-model="image.code" placeholder="请输入验证码"> </ul-input>
        </ul-form-item>
        <ul-button type="primary" class="btn-submit" @click="checkImageCode"
          >确定</ul-button
        >
      </ul-form>
    </div>
    <div class="form-container" v-show="mode == 4">
      <div class="back" @click="cancelPhoneLogin">
        <i class="iconfont icon-zuoye"></i><span>返回</span>
      </div>
      <h1 class="form-title">机构账号登录</h1>
      <div class="form-info">
        已注册并绑定过学号/工号的账号，可使用机构名称、学号/工号、密码登录优学院。
      </div>
      <ul-form
        class="form-login"
        ref="loginFormOrg"
        :model="user"
        :rules="rulesOrg"
      >
        <ul-form-item prop="orgName" label-width="0">
          <ul-autocomplete
            class="school"
            ref="school"
            v-model="user.orgName"
            value-key="orgName"
            :popper-append-to-body="false"
            :fetch-suggestions="querySearch"
            @select="handleSelect"
            @change="handleChange"
            @focus="clearShow = true"
            placeholder="机构名称"
          >
            <i
              slot="suffix"
              class="iconfont icon-caozuoguanbi"
              v-show="clearShow && user.orgName.length > 0"
              @click="clear"
            ></i>
            <!-- <i slot="suffix" class="iconfont icon-xialacaozuo"></i> -->
          </ul-autocomplete>
        </ul-form-item>
        <ul-form-item prop="loginName" label-width="0">
          <ul-input v-model="user.loginName" placeholder="学号/工号"></ul-input>
        </ul-form-item>
        <ul-form-item prop="password" label-width="0" :error="errorMsg">
          <ul-input
            v-model="user.password"
            type="password"
            show-password
            placeholder="密码"
          ></ul-input>
        </ul-form-item>
        <ul-button
          class="btn-submit"
          style="margin-bottom: 24px"
          type="primary"
          @click="loginOrg"
          >登录</ul-button
        >
      </ul-form>
    </div>
    <div class="login-tips">
      登录即为同意优学院
      <a :href="`${UMOOC_SERVER_HOST}/agreements/user.html`">《用户协议》</a> 与
      <a :href="`${UMOOC_SERVER_HOST}/agreements/privacy.html`">《隐私政策》</a>
    </div>

    <template v-slot:footer>
      <div class="others-container mobile-others" v-show="mode == 1">
        <div class="others-title">
          <div class="line">
            <div class="title">其他登录方式</div>
          </div>
        </div>
        <div class="others-wrapper">
          <div class="others-item" @click="orgLoginSwitch">
            <i class="iconfont icon-jigouzhanghao"></i>
            <div class="desc">机构账号</div>
          </div>
          <div class="others-item" @click="mode = 2">
            <i class="iconfont icon-duanxin"></i>
            <div class="desc">短信</div>
          </div>
          <div class="others-item" @click="wxLogin" v-if="showWxLogin">
            <i class="iconfont icon-wechat"></i>
            <div class="desc">微信</div>
          </div>
        </div>
      </div>
    </template>
  </ul-page>
</template>

<script>
import Login from "pc/components/login.vue";
import User from "@/model/user.js";
import { device } from "@/utils/device.js";
import { getImgCode, checkSendsms, getAllOrgan } from "@/api/courseApi";
import { hostDomain, UMOBILE_HOST, UMOOC_SERVER_HOST } from "@/config";
import { mapGetters } from "vuex";
import { wxLogin, welinkLogin } from "@/utils/index.js";
import cookies from "@/utils/cookie";
export default {
  name: "login",
  components: {
    Login,
  },
  data() {
    return {
      hostDomain,
      UMOBILE_HOST,
      UMOOC_SERVER_HOST,
      user: new User(),
      mode: 1, // 1账号登录 2手机号登录 3图形验证码 4机构登录
      errorMsg: "", //账号密码登录不成功提示
      phoneErrorMsg: "", //电话验证码登录不正确提示
      image: {
        code: "", //图形验证码
        url: "", // 图形验证码图片链接
        errorMsg: "",
        verKey: "", //图形验证码key
      },
      remaining: 60, //倒计时剩余时间
      options: [],
      schoolName: null,
      value: "",
      rules: {
        loginName: [
          {
            required: true,
            message: "请输入用户名/手机号/邮箱",
            trigger: "change",
          },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" },
        ],
        code: [
          { required: true, message: "请输入动态验证码", trigger: "blur" },
        ],
      },
      rulesPhone: {
        cellphone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[0-9]{10}$/,
            message: "手机号格式错误",
            trigger: "blur",
          },
        ],
        code: [
          { required: true, message: "请输入动态验证码", trigger: "blur" },
        ],
      },
      rulesOrg: {
        orgName: [{ required: true, message: "请选择机构", trigger: "change" }],
        loginName: [
          { required: true, message: "请输入学号/工号", trigger: "change" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "change" },
        ],
      },
      showWxLogin: device.platform.weixin || !device.isMobile,
      showWelink: !device.isMobile,
      clearShow: false,
    };
  },
  created() {
    // 二级站点登录之后 写入loginFrom cookie 用于退出登录之后跳转回二级站点主页
    if (!this.org.isMainSite) {
      return cookies.set("loginFrom", window.location.origin);
    }
    if (this.user.orgId == -1) {
      this.user.orgId = null;
    }
  },
  computed: {
    ...mapGetters({ account: "user/user", org: "org/org" }),
  },
  mounted() {
    if (this.$route.query.loginName) {
      this.user.loginName = this.$route.query.loginName;
      this.user.getCheatInfo().then((books) => {
        let cheatTips = "";
        if (books.length > 0) {
          cheatTips = books.map((item) => `《${item.name}》`).join("、");
          return this.$message({
            message: `系统检测到此账号在${cheatTips}课程学习中存在作弊等不当行为，系统已自动冻结此账号，请联系任课老师或平台进行处理`,
            type: "warning",
          });
        }
      });
    }
  },
  methods: {
    wxLogin,
    welinkLogin,
    clear() {
      this.user.orgName = "";
      this.clearShow = false;
      this.$nextTick(() => {
        this.$refs.school.focus();
      });
    },
    querySearch(queryString, cb) {
      var restaurants = this.options;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      if (results.length > 0) {
        cb(results);
      } else {
        cb([]);
      }
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.orgName
            .toLowerCase()
            .indexOf(queryString.toLowerCase()) !== -1
        );
      };
    },
    handleSelect(schoolItem) {
      this.user.orgId = schoolItem.orgId;
    },
    handleChange(value) {
      let org = this.options.filter((item) => {
        return item.orgName == value;
      });
      if (org.length > 0) {
        this.user.orgId = org[0].orgId;
      } else {
        this.user.orgName = null;
      }
    },
    login() {
      this.$refs.login.login();
    },
    loginPhone() {
      this.phoneErrorMsg = "";
      this.$refs["loginFormPhone"].validate((valid, detail) => {
        if (valid) {
          if (this.isPhoneLogining) {
            return;
          }
          this.isPhoneLogining = true;

          this.user.loginName = this.user.cellphone;
          // 登录保护
          this.user.getCheatInfo().then((books) => {
            let cheatTips = "";
            if (books.length > 0) {
              cheatTips = books.map((item) => `《${item.name}》`).join("、");
              return this.$message({
                message: `系统检测到此账号在${cheatTips}课程学习中存在作弊等不当行为，系统已自动冻结此账号，请联系任课老师或平台进行处理`,
                type: "warning",
              });
            } else {
              this.user
                .checkcode()
                .then((data) => {
                  this.isPhoneLogining = false;
                  if (data.status == 1) {
                    this.user.phoneLogin();
                  } else {
                    // this.$message({
                    //   message: data.message,
                    //   type: 'warning'
                    // })
                    this.phoneErrorMsg = data.message;
                  }
                })
                .catch((err) => {
                  this.isPhoneLogining = false;
                });
            }
          });
        }
      });
    },
    loginOrg() {
      this.errorMsg = "";
      this.$refs["loginFormOrg"].validate((valid, detail) => {
        if (valid) {
          this.user.getCheatInfo("org").then((books) => {
            let cheatTips = "";
            if (books.length > 0) {
              cheatTips = books.map((item) => `《${item.name}》`).join("、");
              return this.$message({
                message: `系统检测到此账号在${cheatTips}课程学习中存在作弊等不当行为，系统已自动冻结此账号，请联系任课老师或平台进行处理`,
                type: "warning",
              });
            }
            this.checkLoginName();
          });
        }
      });
    },
    checkLoginName() {
      this.user.checkLoginName("org").then((data) => {
        if (data.code == 1) {
          if (data.result == 3) {
            return (this.errorMsg = "您已经连续输错5次，3分钟后重试");
          } else if (data.result == 1) {
            // 校验通过
            this.user.orgLogin();
          } else if (data.result == 16) {
            // 机构登录不可使用
            this.$message({
              message: data.message || "禁止登录",
              type: "error",
              dangerouslyUseHTMLString: true,
              duration: 0,
              showClose: true,
            });
            return false;
          } else {
            this.errorMsg = "学号/工号或密码错误";
          }
        }
      });
    },
    orgLoginSwitch() {
      this.mode = 4;
      getAllOrgan().then((res) => {
        this.options = res;
        if (
          localStorage.getItem("ulearning-orgId") &&
          localStorage.getItem("ulearning-orgId") != -1
        ) {
          this.user.orgId = parseInt(localStorage.getItem("ulearning-orgId"));
          let org = this.options.filter((item) => {
            return item.orgId == this.user.orgId;
          });
          this.user.orgName = org[0].orgName;
        }
      });
    },
    cancelPhoneLogin() {
      this.user.cellphone = "";
      this.user.code = "";
      this.mode = 1;
      this.$refs["loginFormPhone"].clearValidate();
    },
    cancelImageCode() {
      this.image.code = "";
      this.mode = 2;
    },
    getPhoneCode() {
      let errMsgs = [];
      this.$refs["loginFormPhone"].validateField(
        ["cellphone"],
        (err, detail) => {
          errMsgs.push(err);
        }
      );
      if (errMsgs.every((item) => item === "")) {
        this.getImgCode();
      }
    },
    getImgCode() {
      getImgCode().then((data) => {
        this.mode = 3;
        this.image.errorMsg = "";
        this.image.url = data.image;
        this.image.verKey = data.verKey;
      });
    },
    checkImageCode() {
      if (this.image.code == "") {
        this.image.errorMsg = "请输入验证码";
      } else {
        checkSendsms({
          captcha: this.image.code,
          cellphone: this.user.cellphone,
          regionCode: 86,
          verKey: this.image.verKey,
        }).then((data) => {
          if (data.status == 1) {
            this.mode = 2;
            this.startTimer();
          } else {
            this.image.errorMsg = data.message;
          }
        });
      }
    },
    startTimer() {
      this.remaining = 59;
      let timer = setInterval(() => {
        this.remaining--;
        if (this.remaining == 0) {
          clearInterval(timer);
        }
      }, 1000);
    },
    toRegister() {
      let url = UMOBILE_HOST + "/#/user/register";
      // let url = 'http://localhost:8081/#/user/register'
      if (device.isMobile) {
        url = UMOBILE_HOST + "/#/user/choseRegisterType";
      }
      location.href = url;
    },
    toFindPwd() {
      // window.open('UMOBILE_HOST + '/#/user/findPassword')
      location.href = UMOBILE_HOST + "/#/user/findPassword";
    },
    toHome() {
      if (this.$route.query.domain == "hnylkc") {
        window.location.href = `http://hnylkc${hostDomain}`;
      } else {
        if (this.org.isMainSite) {
          return (window.location.href = `${UMOOC_SERVER_HOST}`);
        }
        return (window.location.href = `https://${
          this.org.prefix + hostDomain
        }`);
      }
    },
    getHelp() {
      var config = {
        // uid: self.user.id(),
        // uname: self.user.name(),
        exterinfo: {
          url: encodeURI(window.location.href),
          userAgent: encodeURI(window.navigator.userAgent),
        },
        system: "web",
      };
      if (this.account.userId) {
        config.userId = this.account.userId;
        config.uname = this.account.name;
      }
      xn("setCustomerInfo", config);
      xn("openChat", "kf_20125_template_9999");
    },
  },
};
</script>

<style lang="scss" scoped>
.page-header-right {
  span {
    display: inline-block;
    padding: 0 12px;
    cursor: pointer;
    &:hover {
      color: $--color-primary;
    }
    &:not(:last-child) {
      border-right: $--border-base;
    }
  }
}
.banner {
  height: 160px;
  background-image: url(~@/assets/images/login_banner.png);
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.mobile-logo {
  display: none;
}
.mobile-others {
  display: none;
}
::v-deep {
  .ul-page__body-content {
    background-color: inherit;
  }
}
::v-deep.school {
  width: 100%;
  .ul-popper {
    left: 0px !important;
  }
  .ul-autocomplete-suggestion__wrap {
    padding: 2px 0;
    li {
      white-space: normal;
    }
  }
  .ul-input__suffix {
    line-height: 44px;
    i {
      color: #444;
      font-size: 8px;
    }
    .icon-caozuoguanbi {
      color: #dedede;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
.form-container {
  position: relative;
  width: 800px;
  margin: -90px auto 0;
  padding: 48px;
  background-color: $--color-white;
  border-radius: 4px;
  .form-title {
    margin: 0 0 32px;
    font-size: 30px;
    text-align: center;
    font-weight: normal;
  }
  .form-info {
    width: 420px;
    height: 60px;
    background: #fcf5ec;
    margin: 0 auto;
    margin-bottom: 32px;
    padding: 10px;
    color: #888888;
    line-height: 20px;
    font-size: 14px;
  }
  .back {
    position: absolute;
    left: 20px;
    top: 20px;
    cursor: pointer;
    color: $--color-text-secondary;
    i {
      color: $--color-text-secondary;
      font-size: 14px;
    }
    &:hover {
      color: $--color-primary;
      i {
        color: $--color-primary;
      }
    }
  }
}
.form-login {
  width: 420px;
  margin: 0 auto;
  ::v-deep {
    .ul-input__inner {
      height: 44px;
      line-height: 44px;
    }
    .ul-input__suffix-inner {
      .icon-xianshi,
      .icon-yincang {
        font-size: 16px;
      }
    }
    .ul-input {
      line-height: 44px;
    }
    .ul-select {
      height: 44px;
      line-height: 44px;
      width: 100%;
      background-color: #fff;
      .ul-input__inner {
        background-color: #fff;
      }
    }
    .form-item-code {
      .ul-form-item__content {
        display: flex;
      }
      .ul-input {
        flex: 1;
        margin-right: 12px;
      }
    }
    .ul-input-group__prepend {
      line-height: 24px;
      background-color: $--color-white;
    }
  }
  .ul-button {
    padding: 14px 20px;
  }
  .phone-tips {
    color: $--color-text-secondary;
    font-size: 12px;
  }
}
.image-code-wrapper {
  text-align: center;
}
.btn-submit {
  margin-top: 18px;
  width: 100%;
}
.register {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  a {
    color: $--color-text-base;
    &:hover {
      color: $--color-primary;
    }
  }
}
.register-pc {
  display: flex;
}
.register-mobile {
  display: none;
}
.others-title {
  .line {
    position: relative;
    height: 1px;
    margin-top: 32px;
    background-color: $--border-color-base;
    .title {
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%);
      background-color: #fff;
      padding: 0 9px;
      color: $--color-text-secondary;
    }
  }
}
.others-wrapper {
  display: flex;
  margin-top: 26px;
  justify-content: center;
  .others-item {
    padding: 0 26px;
    text-align: center;
    cursor: pointer;
    &:hover {
      .desc {
        color: $--color-primary;
      }
    }
    .welink-icon {
      display: block;
      margin: 0 auto;
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
  i {
    display: inline-block;
    border-radius: 100%;
    height: 40px;
    width: 40px;
    text-align: center;
    color: #fff;
    line-height: 40px;
    font-size: 16px;
  }
  .icon-jigouzhanghao {
    background: linear-gradient(180deg, #b8cfff, #8cb0fd 100%);
  }
  .icon-duanxin {
    background: linear-gradient(180deg, #93ebff, #3bbfff);
    font-size: 14px;
  }
  .icon-wechat {
    background: linear-gradient(180deg, #59de8d, #63d493 98%);
  }
  .desc {
    margin-top: 8px;
    color: $--color-text-secondary;
  }
}
.login-tips {
  display: none;
}
@media (max-width: 768px) {
  .banner {
    display: none;
  }
  .pc-others {
    display: none;
  }
  .mobile-others {
    display: block;
    margin-bottom: 36px;
    padding: 0 70px;
    .others-title {
      .title {
        font-size: 12px;
      }
    }
    .others-wrapper {
      margin-top: 24px;
      .others-item {
        flex: 1;
        padding: 0px;
        i {
          width: 36px;
          height: 36px;
          line-height: 36px;
          font-size: 14px;
          // background: #fff;
        }
        .icon-duanxin {
          font-size: 12px;
        }
        .desc {
          font-size: 12px;
        }
      }
    }
  }
  .mobile-logo {
    display: block;
    padding: 42px 0 16px 0;
    text-align: center;
    img {
      height: 40px;
    }
  }
  .form-container {
    position: initial;
    width: 100%;
    margin: 0;
    padding: 20px;
    .form-title {
      display: none;
    }
    .form-info {
      display: none;
    }
    .form-login {
      width: auto;
    }
  }
  .register-pc {
    display: none;
  }
  .register-mobile {
    display: flex;
  }
  .login-tips {
    display: block;
    margin-top: 4px;
    text-align: center;
    font-size: 12px;
    a {
      color: $--color-primary;
    }
  }
}
</style>